module.exports = __webpack_public_path__ + "static/media/科研医疗.ed9874df.svg";